// File: `src/pages/Wallet/adminTopUp.tsx`
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "antd";
import { Controller, useForm } from "react-hook-form";
import { TopUpSchema } from "validations";
import Input from "comps/Input";
import { useAdminTopUp } from "../../hooks/useAdminTopUp";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";

type Props = {
    loginModal: boolean;
    setLoginModal: (v: boolean) => void;
    handlegetWallet?: () => void;
    handleGetWalletKPI?: () => void;
    merchantId?: string;
};

const AdminTopUpModal = ({ loginModal, setLoginModal, handlegetWallet, handleGetWalletKPI, merchantId }: Props) => {
    const params = useParams();
    const finalMerchantId = merchantId ?? params.userId ?? params.merchantId ?? params.id;

    const { adminDeposit, loading, setError } = useAdminTopUp();

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: { amount: "" },
        mode: "onTouched",
        resolver: yupResolver(TopUpSchema),
    });

    const onSubmit = async (data: any) => {
        try {
            if (setError) setError(null);

            if (!finalMerchantId) {
                const msg = "Missing merchant id";
                if (setError) setError(msg);
                return;
            }

            const amount = data?.amount;
            const result = await adminDeposit(finalMerchantId, amount);

            const txnRef =
                result?.data?.transactionRef ??
                result?.data?.transaction?.reference ??
                result?.data?.reference ??
                result?.data?.data?.transactionRef ??
                "";

            if (result?.data) {
                const newSearch = new URLSearchParams(searchParams.toString());
                newSearch.set("status", "SUCCESS");
                if (txnRef) newSearch.set("transactionRef", String(txnRef));

                navigate(`${location.pathname}?${newSearch.toString()}`, { replace: true });

                setValue("amount", "");
                setLoginModal(false);

                if (typeof handlegetWallet === "function") handlegetWallet();
                if (typeof handleGetWalletKPI === "function") handleGetWalletKPI();
            }
        } catch (err: any) {
            if (setError) setError(err?.message || String(err));
        }
    };

    return (
        <Modal
            open={loginModal}
            title="Fund Wallet"
            onCancel={() => setLoginModal(false)}
            okText="Pay Now"
            okButtonProps={{ htmlType: "submit" }}
            onOk={handleSubmit(onSubmit)}
            confirmLoading={loading}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col gap-y-5">
                    <Controller
                        name="amount"
                        control={control}
                        render={({ field }) => (
                            <Input
                                {...field}
                                label="Amount"
                                type="number"
                                placeholder="Enter amount"
                                extraClass="w-full"
                                error={errors.amount?.message}
                            />
                        )}
                    />
                </div>
            </form>
        </Modal>
    );
};

export default AdminTopUpModal;